module.exports = __webpack_public_path__ + "img/code2.6d50fbc0.png";